export default __webpack_public_path__ + "static/Black-Background-Tile-2x-157406ef0188cf4c0d8b9316058706cb.webp";